import { Button } from '../shadcn/Button';
import { Dialog } from './Dialog';
import Notice from './Notice';
import { ReactNode, useState } from 'react';

export interface ConfirmDialogProps {
    title?: string;
    message?: ReactNode;
    acknowledgement?: string;
    confirmVariant?: 'primary' | 'destructive';
    onConfirm: () => Promise<true | string>;
    onClose: () => void;
}

export function ConfirmDialog({
    title,
    message,
    acknowledgement,
    confirmVariant = 'primary',
    onConfirm,
    onClose
}: ConfirmDialogProps) {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [acknowledged, setAcknowledged] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        setError(null);

        try {
            const result = await onConfirm();
            if (result === true) {
                onClose?.();
            } else {
                setError(result);
            }
        } catch (err) {
            console.error(err);
            setError('Ha ocurrido un error inesperado');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog title={title || ""} onClose={onClose} closable={false}>
            <form className="flex flex-col gap-4 pt-1" onSubmit={(e) => {
                e.preventDefault();
                handleConfirm();
            }}>
                {message && (
                    <div className="text-neutral-200">{message}</div>
                )}

                {acknowledgement && (
                    <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-neutral-800 bg-neutral-950/30 p-3 text-sm text-neutral-200">
                        <input
                            type="checkbox"
                            checked={acknowledged}
                            onChange={(event) => setAcknowledged(event.target.checked)}
                            disabled={loading}
                            className="mt-0.5 size-4 shrink-0 accent-red-500"
                        />
                        <span>{acknowledgement}</span>
                    </label>
                )}

                {error && (
                    <Notice message={error} variant="error" />
                )}

                <div className="flex justify-end gap-3 mt-2">
                    <Button
                        disabled={loading}
                        variant="secondary"
                        onClick={onClose}
                        className="w-fit"
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        variant={confirmVariant}
                        loading={loading}
                        disabled={Boolean(acknowledgement) && !acknowledged}
                        className="w-fit"
                    >
                        Confirmar
                    </Button>
                </div>
            </form>
        </Dialog>
    );
}

